import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface ActionStripProps {
  primaryLabel: string;
  primaryDisabled?: boolean;
  primaryBusy?: boolean;
  onPrimary: () => void;

  backLabel?: string | null;
  onBack?: (() => void) | null;
}

export function ActionStrip({
  primaryLabel,
  primaryDisabled = false,
  primaryBusy = false,
  onPrimary,
  backLabel,
  onBack,
}: ActionStripProps) {
  return (
    <div className="flex justify-between items-center gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      {backLabel && onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="text-sm text-muted-foreground hover:text-[#004250]"
        >
          {backLabel}
        </button>
      ) : (
        <span />
      )}
      <Button
        type="button"
        onClick={onPrimary}
        disabled={primaryDisabled || primaryBusy}
        className="bg-[#7dda55] hover:bg-[#6bc748] text-white"
      >
        {primaryBusy && <Loader2 className="me-2 h-4 w-4 animate-spin" />}
        {primaryLabel}
      </Button>
    </div>
  );
}
